import { SelectionModel } from "@angular/cdk/collections";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { GrupoServicioSolicitadoDTO } from "app/main/apps/shared/interfaces/grupo-servicio-solicitado.interface";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { fuseAnimations } from "@fuse/animations";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { ContratistaService } from "app/main/apps/shared/services/rest/contratista.service";
import { ContratistaDTO } from "app/main/apps/shared/models/contratista.model";

@Component({
    selector: "app-especialidades-solicitadas",
    templateUrl: "./especialidades-solicitadas.component.html",
    styleUrls: ["./especialidades-solicitadas.component.scss"],
    animations: fuseAnimations,
})
export class EspecialidadesSolicitadasComponent implements OnInit {
    @Input() grupoServiciosSolicitados: GrupoServicioSolicitadoDTO[];
    @Input() contratista: ContratistaDTO;
    @Input() eliminado: boolean;
    @Output() aprobarSolicitudEvent: EventEmitter<
        GrupoServicioSolicitadoDTO[]
    > = new EventEmitter();

    esSupervisor: boolean = false;
    total: number = 0;

    dataSource: MatTableDataSource<GrupoServicioSolicitadoDTO>;
    displayedColumns = ["select", "nombre", "fecha"];
    selection = new SelectionModel<any>(true, []);

    constructor(
        private _menuUsuarioSrvc: MenuUsuarioService,
        private _contratistaSrvc: ContratistaService
    ) {}

    ngOnInit(): void {
        this.esSupervisor = this._menuUsuarioSrvc.esSupervisor();
        this.total = this.grupoServiciosSolicitados.length;
        this.dataSource = new MatTableDataSource(
            this.grupoServiciosSolicitados
        );

        this._contratistaSrvc.contratistaChanged$.subscribe((resp) => {
            //console.log("llego a cambiar los grupos");
            this._contratistaSrvc
                .fetchGrupoServicioSolicitado(this.contratista.nrRut)
                .subscribe((resp) => {
                    this.grupoServiciosSolicitados = resp;
                    this.total = this.grupoServiciosSolicitados.length;
                    this.dataSource = new MatTableDataSource(
                        this.grupoServiciosSolicitados
                    );
                });
        });
    }

    aprobar() {
        //console.log(this.selection.selected);
        this.aprobarSolicitudEvent.emit(this.selection.selected);
    }

    borrar() {}

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    checkboxLabel(row?: any): string {
        if (!row) {
            return `${this.isAllSelected() ? "select" : "deselect"} all`;
        }
        return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
            row.position + 1
        }`;
    }

    toggleSelect(event: MatCheckboxChange, grupo: GrupoServicioSolicitadoDTO) {
        event ? this.selection.toggle(grupo) : null;
    }
}
